export const firebaseConfig = {
  apiKey: "AIzaSyCyOgW6zEfYOQXpuThVEAmhv42YihKVPyE",
  authDomain: "wedding-db244.firebaseapp.com",
  databaseURL:
    "https://wedding-db244-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "wedding-db244",
  storageBucket: "wedding-db244.appspot.com",
  messagingSenderId: "827235607952",
  appId: "1:827235607952:web:57dedaede9a67913acbf15",
  measurementId: "G-P791F40TXV",
};
